import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import MatchesSection from './components/MatchesSection';
import CategorySection from './components/CategorySection';
import ArticlesSection from './components/ArticlesSection';
import TrustSection from './components/TrustSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import {
  getOrganizationSchema,
  getWebsiteSchema,
  getWebPageSchema,
  getFAQSchema,
} from '@/components/base/SEOHead';

export default function Home() {
  useEffect(() => {
    const organizationLD = document.createElement('script');
    organizationLD.type = 'application/ld+json';
    organizationLD.textContent = JSON.stringify(getOrganizationSchema(), null, 2);
    document.head.appendChild(organizationLD);

    const websiteLD = document.createElement('script');
    websiteLD.type = 'application/ld+json';
    websiteLD.textContent = JSON.stringify(getWebsiteSchema(), null, 2);
    document.head.appendChild(websiteLD);

    const webpageLD = document.createElement('script');
    webpageLD.type = 'application/ld+json';
    webpageLD.textContent = JSON.stringify(
      getWebPageSchema(
        '华体会官网 - 官方正版入口，安全可信赖',
        '华体会官网是您体验顶级体育娱乐的首选平台，提供安全稳定的官方正版入口，汇聚海量体育赛事、实时赔率与专业竞猜服务。',
        'https://www.huatiyuiguanwang.com/'
      ),
      null,
      2
    );
    document.head.appendChild(webpageLD);

    const faqLD = document.createElement('script');
    faqLD.type = 'application/ld+json';
    faqLD.textContent = JSON.stringify(
      getFAQSchema([
        {
          question: '华体会官网是正规平台吗？',
          answer: '华体会官网是持有正规运营牌照的体育娱乐平台，采用国际领先的安全加密技术，严格遵守行业规范，为广大用户提供安全可靠的体育竞猜服务。',
        },
        {
          question: '如何在华体会官网注册账号？',
          answer: '访问华体会官网首页，点击立即注册按钮，填写手机号或邮箱地址，设置登录密码，完成手机验证即可成功注册。',
        },
        {
          question: '华体会官网支持哪些充值方式？',
          answer: '华体会官网支持多种充值方式，包括银行卡转账、微信支付、支付宝、USDT数字货币等多种渠道，充值实时到账。',
        },
        {
          question: '华体会官网提现需要多长时间？',
          answer: '华体会官网提现处理效率极高，一般情况下小额提现5分钟内到账，大额提现24小时内处理完成。',
        },
        {
          question: '华体会官网有哪些体育竞猜项目？',
          answer: '华体会官网覆盖足球、篮球、网球、电竞、乒乓球、羽毛球、F1赛车、高尔夫等数十种体育项目。',
        },
        {
          question: '华体会官网会员福利有哪些？',
          answer: '华体会官网为新会员提供注册礼金和首充优惠；为老会员提供每日签到奖励、周周返水、节日专属活动、VIP等级特权等多重福利。',
        },
      ]),
      null,
      2
    );
    document.head.appendChild(faqLD);

    return () => {
      document.querySelectorAll('script[type="application/ld+json"]').forEach((el) => {
        if (el.textContent?.includes('华体会官网') || el.textContent?.includes('FAQPage') || el.textContent?.includes('WebPage')) {
          el.remove();
        }
      });
    };
  }, []);

  const handleNewsletterSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      const successEl = document.getElementById('newsletter-success');
      if (successEl) successEl.classList.remove('hidden');
      form.reset();
      return;
    }
    const submitUrl = 'https://readdy.ai/api/form/d9qt5psnlsngrm4lm5k0';
    const params = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key !== 'phone_alt') {
        params.append(key, value as string);
      }
    });
    fetch(submitUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    })
      .then(async (res) => {
        const text = await res.text();
        let parsed;
        try { parsed = JSON.parse(text); } catch { parsed = null; }
        if (res.ok && parsed?.code === 'OK') {
          const successEl = document.getElementById('newsletter-success');
          if (successEl) successEl.classList.remove('hidden');
          form.reset();
        } else {
          const errEl = document.getElementById('newsletter-error');
          if (errEl) {
            errEl.textContent = parsed?.meta?.message || parsed?.message || '提交失败，请稍后再试';
            errEl.classList.remove('hidden');
          }
        }
      })
      .catch(() => {
        const errEl = document.getElementById('newsletter-error');
        if (errEl) {
          errEl.textContent = '网络错误，请稍后再试';
          errEl.classList.remove('hidden');
        }
      });
  };

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <MatchesSection />
        <CategorySection />
        <ArticlesSection />

        <section className="w-full py-12 md:py-16 bg-background-50">
          <div className="w-full px-4 md:px-6 max-w-2xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              订阅最新赛事资讯
            </h2>
            <p className="text-sm text-foreground-600 mb-6">
              第一时间获取华体会官网最新赛事资讯、竞猜攻略和会员福利信息
            </p>
            <form
              data-readdy-form
              id="newsletter-form"
              onSubmit={handleNewsletterSubmit}
              className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
            >
              <input
                type="email"
                name="email"
                placeholder="请输入您的邮箱地址"
                required
                className="flex-1 px-4 py-2.5 text-sm rounded-md border border-background-300 bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-accent-500 focus:ring-1 focus:ring-accent-400 transition-colors duration-200"
              />
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="form-honeypot"
              />
              <button
                type="submit"
                className="px-6 py-2.5 bg-accent-500 text-background-50 text-sm font-semibold rounded-md hover:bg-accent-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                订阅资讯
              </button>
            </form>
            <p id="newsletter-success" className="hidden mt-4 text-sm text-primary-700 font-medium">
              订阅成功！感谢您关注华体会官网。
            </p>
            <p id="newsletter-error" className="hidden mt-4 text-sm text-accent-700 font-medium"></p>
          </div>
        </section>

        <TrustSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}